import { ILanguage } from '@/interfaces/languages'

import brIcon from '../static/images/br.png'
import usIcon from '../static/images/usa.png'
import esIcon from '../static/images/spain.png'

export const Languages: ILanguage[] = [
    { lang: 'pt-br', icon: brIcon },
    { lang: 'en', icon: usIcon },
    { lang: 'es', icon: esIcon },
]